import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      {/* Hexagon Border */}
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        d="M 50, 5
           L 11, 27
           L 11, 72
           L 50, 95
           L 89, 73
           L 89, 28 Z"
      />

      {/* Centered RV Initials */}
      <g transform="translate(22, 31) scale(0.7)">
        <path
          fill="currentColor"
          d="M 65.7 53.325 L 57.675 53.325 L 38.4 2.7 L 45.375 0 L 61.875 45.525 L 78.45 0.225 L 84.9 2.7 L 65.7 53.325 Z M 37.275 51.075 L 30.6 54.225 L 24.075 39.975 Q 21.6 34.65 17.85 32.4 A 17.9 17.9 0 0 0 8.973 30.159 A 29.414 29.414 0 0 0 8.25 30.15 L 7.125 30.15 L 7.125 53.325 L 0 53.325 L 0 0.975 Q 3.975 0.6 7.612 0.412 Q 11.25 0.225 15.375 0.225 A 30.934 30.934 0 0 1 24.668 1.459 A 15.622 15.622 0 0 1 29.812 4.125 Q 34.65 8.025 34.65 14.175 Q 34.65 19.65 31.387 22.987 A 19.111 19.111 0 0 1 23.286 27.594 A 32.096 32.096 0 0 1 21.975 27.975 Q 24 28.875 25.575 30.112 Q 27.15 31.35 28.612 33.412 Q 30.075 35.475 31.575 38.775 L 37.275 51.075 Z M 7.125 6.525 L 7.125 24.15 L 15.375 24.15 Q 20.775 24.15 24.15 21.75 Q 27.525 19.35 27.525 14.85 Q 27.525 11.1 24.375 8.662 A 13.099 13.099 0 0 0 17.137 6.285 A 25.193 25.193 0 0 0 15.375 6.225 Q 12.825 6.225 10.8 6.3 Q 8.775 6.375 7.125 6.525 Z"
        />
      </g>
    </g>
  </svg>
);

export default IconLoader;
